import React from "react";
import { site } from "../data/site";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/ui-blocks";
import { IMG } from "../data/site";

const P = ({ children }) => <p className="text-neutral-600 leading-relaxed mb-5">{children}</p>;
const H = ({ children }) => <h2 className="text-2xl mt-10 mb-3">{children}</h2>;

const Privacy = () => (
  <div>
    <Seo title="Privacy Policy" description="Privacy Policy for the Premier Granite LLC website." path="/privacy" image={IMG.graniteTexture} />
    <PageHero eyebrow="Legal" title="Privacy Policy" image={IMG.stoneGrey} testid="privacy-hero" />
    <section className="section bg-white">
      <div className="container-custom max-w-3xl">
        <P>This Privacy Policy explains how {site.name} ("we," "us") handles information collected through this website. It applies to information submitted to us via our website forms and related communications.</P>

        <H>Information You Provide</H>
        <P>When you request an estimate or contact us, you may provide your name, phone number, email address, city, ZIP code and details about your project. You may also choose to upload photos or plans related to your project.</P>

        <H>Project Photos & Uploads</H>
        <P>Files you upload with an estimate request are used solely to help us understand and respond to your request. Uploaded files are stored securely and are not published publicly on this website.</P>

        <H>How We Use Your Information</H>
        <P>We use the information you provide to respond to your estimate request, communicate with you about your project and provide our services. We do not sell your personal information.</P>

        <H>Cookies & Analytics</H>
        <P>This website may use cookies and analytics tools to understand general site usage and improve the experience. Where analytics are enabled, they are used to measure aggregate activity, not to identify you personally.</P>

        <H>Data Retention</H>
        <P>We retain estimate requests and related information for as long as needed to respond to your inquiry and for our legitimate business purposes.</P>

        <H>Contact Us</H>
        <P>For any privacy-related questions, contact us at <a href={site.emailHref} className="text-[#CD1422] font-medium">{site.email}</a>.</P>

        <p className="text-sm text-neutral-400 mt-8">Last updated: {new Date().getFullYear()}. This policy may be updated from time to time.</p>
      </div>
    </section>
  </div>
);

export default Privacy;
